import { gql } from '@apollo/client';

export const BOARDS_LIST_QUERY = gql`
  query BoardsList {
    boards {
      id
      name
      start_date
      end_date
      created_at
      updated_at
      board_columns {
        id
        name
        position
        is_default
        progress_type
      }
    }
  }
`;

export const BOARD_QUERY = gql`
  query Board($id: ID!) {
    board(id: $id) {
      id
      name
      start_date
      end_date
      archived
      created_at
      updated_at
      board_columns {
        id
        name
        position
        is_default
        progress_type
        tasks {
          id
          name
          description
          complete
          start_date
          end_date
          task_type {
            id
            name
          }
          project {
            id
            name
          }
          element {
            id
            name
          }
          companies {
            id
            name
          }
          responsible {
            id
            first_name
            last_name
            uuid
          }
        }
      }
    }
  }
`;

export const CREATE_OR_UPDATE_BOARD = gql`
  mutation CreateOrUpdateBoard($id: ID, $name: String, $start_date: String, $end_date: String) {
    createOrUpdateBoard(id: $id, name: $name, start_date: $start_date, end_date: $end_date) {
      board {
        id
        name
        start_date
        end_date
      }
      errors
    }
  }
`;

export const DESTROY_BOARD = gql`
  mutation DestroyBoard($id: ID!, $target_board_column_id: Int) {
    destroyBoard(id: $id, target_board_column_id: $target_board_column_id) {
      success
    }
  }
`;

export const CREATE_OR_UPDATE_BOARD_COLUMN = gql`
  mutation CreateOrUpdateBoardColumn($id: ID, $board_id: Int, $name: String, $position: Int, $progress_type: String) {
    createOrUpdateBoardColumn(id: $id, board_id: $board_id, name: $name, position: $position, progress_type: $progress_type) {
      board_column {
        id
        name
        position
        is_default
        progress_type
      }
      errors
    }
  }
`;

export const DESTROY_BOARD_COLUMN = gql`
  mutation DestroyBoardColumn($id: ID!) {
    destroyBoardColumn(id: $id) {
      success
    }
  }
`;
